import { Box, Grid, MenuItem, Pagination, Stack, TextField } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  categorySelector,
  getCategoriesThunk,
} from "store/reducers/product/categorySlice";
import {
  getProductsThunk,
  productSelector,
} from "store/reducers/product/productSlice";
import {
  getSubCategoriesThunk,
  subCategorySelector,
} from "store/reducers/product/subCategorySlice";
import AutoCompleteList from "components/AutoCompleteList";
import ProductsList from "pages/products/ProductsList";
import { getHsnThunk } from "store/reducers/product/productGstSlice";

const Products = () => {
  const dispatch = useDispatch();
  const [category, setCategory] = useState(null);
  const [subCategory, setSubCategory] = useState(null);
  const [HSN, setHSN] = useState(null);
  const [gst, setGst] = useState("");

  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(getCategoriesThunk());
  }, []);

  useEffect(() => {
    dispatch(getHsnThunk());
  }, []);

  useEffect(() => {
    if (category) {
      setSubCategory(null);
      dispatch(getSubCategoriesThunk(category.id));
    }
  }, [category]);

  useEffect(() => {
    dispatch(
      getProductsThunk({
        category: category?.id ?? "",
        subCategory: subCategory?.id ?? "",
        hsn: HSN?.HSNCODE ?? "",
        has_gst: gst,
        page: page,
      })
    );
  }, [category, subCategory, HSN, gst,page]);

  const categories = useSelector(categorySelector.selectAll);
  const subCategories = useSelector(subCategorySelector.selectAll).filter(
    (item) => item.category === category?.id
  );

  const hsns = useSelector((state) => state.productGst.HSNS);
  const productState = useSelector((state) => state.product);

  const products = useSelector(productSelector.selectAll);
  const handleChange = (event, value) => {
    setPage(value);
  };
  return (
    <Box>
      <Grid container spacing={1}>
        <Grid item lg={3} md={6} xs={12}>
          <AutoCompleteList
            items={categories}
            name="name"
            label="Filter categories"
            setValue={setCategory}
            value={category}
          />
        </Grid>
        <Grid item lg={3} md={6} xs={12}>
          <AutoCompleteList
            items={subCategories}
            name="name"
            label="Filter subcategories"
            setValue={setSubCategory}
            value={subCategory}
          />
        </Grid>
        <Grid item lg={3} md={6} xs={12}>
          <AutoCompleteList
            items={hsns}
            name="HSNCODE"
            label="Filter by HSN"
            setValue={setHSN}
            value={HSN}
          />
        </Grid>
        <Grid item lg={3} md={6} xs={12}>
          <TextField
            label="GST attached"
            variant="outlined"
            name="gst"
            select
            fullWidth
            value={gst}
            onChange={(e) => setGst(e.target.value)}
            autoComplete="new-password"
          >
            <MenuItem value={"true"}>True</MenuItem>
            <MenuItem value={"false"}>False</MenuItem>
            <MenuItem value={""}>Show All</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      <ProductsList products={products} />
      <Stack direction="row" justifyContent="center" marginTop={2}>
        <Pagination
          count={productState.productPageCount}
          variant="outlined"
          shape="rounded"
          onChange={handleChange}
        />
      </Stack>
    </Box>
  );
};

export default Products;
